export const defaultImgDiameter = '70px';
export const defaultImgDiameterWrapper = '74px';
